var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [_c('Header', {
    attrs: {
      "meta": _vm.meta,
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section')
    }
  }), _vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _vm.deepGet(_vm.bookingPreset, 'config.welcome_page.enable', false) ? [_vm.deepGet(_vm.bookingPreset, 'config.welcome_page.banner_image') ? _c('img', {
    staticClass: "banner-image w-100",
    attrs: {
      "src": _vm.deepGet(_vm.bookingPreset, 'config.welcome_page.banner_image')
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_vm.deepGet(_vm.bookingPreset, 'config.welcome_page.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.bookingPreset, 'config.welcome_page.form_title')) + " ")]) : _vm._e(), _vm.deepGet(_vm.bookingPreset, 'config.welcome_page.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.bookingPreset, 'config.welcome_page.form_desc')) + " ")]) : _vm._e(), _vm.deepGet(_vm.bookingPreset, 'config.welcome_page.content') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.bookingPreset, 'config.welcome_page.content'))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page__button s-space-y-4"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    on: {
      "click": _vm.goToContent
    }
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.bookingPreset, 'config.welcome_page.button_text')) + " ")])], 1)])] : _vm._e()], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }